import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';
import {
    EntryProcedureEntityTableName,
    ModelByEntryProcedureEntityTable,
    RecordByEntryProcedureEntityTable,
} from '../../../../types/EntryProcedure';

const mapRawRecord = <K extends EntryProcedureEntityTableName>(
    record: ModelByEntryProcedureEntityTable[K],
) => {
    return record._raw as unknown as RecordByEntryProcedureEntityTable[K];
};

const toPreparedDataItems = <K extends EntryProcedureEntityTableName>(
    records: ModelByEntryProcedureEntityTable[K][],
    table: K,
    operation: ValidationOperation,
) => {
    return records.map((record) => ({
        record,
        table,
        operation,
    }));
};

const addRelatedDataBatch = async (data: Model[], database: Database) => {
    await database.batch(...data);
};

export { toPreparedDataItems, addRelatedDataBatch, mapRawRecord };
